import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../customTable'
import moment from 'moment'
import _ from 'lodash'
import EditRoundedIcon from "@mui/icons-material/EditRounded";
const DayReports = ({setOpen  , dateData  , setActiveStep, setProductData}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const onClickEdit = (e) => {
        console.log(e.row)
        setProductData(e.row.salesData)
        setActiveStep("2")
    }
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "docDate",
            headerName: "Bill Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "account_name",
            headerName: "Account Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          // {
          //   field: "view",
          //   headerName: "View",
          //   flex: 1,
          //   headerAlign: "center",
          //   align: "center",
          //   sortable: false,
          //   renderCell : (params) => {
          //       return(
          //           <IconButton
          //           size="small"
          //           onClick={() => onClickEdit(params)}
          //           >
          //               <EditRoundedIcon />
          //           </IconButton>
          //       )
          //   }
          // },
    ]
    const rows = _.map(dateData.data,(value,idx) =>({
        id: idx,
        sno: idx+1,
        docNo:value.docno,
        docDate:moment(value.edate).format('DD-MM-YYYY'),
        account_name:value.account_name || "-",
        amount:value.amount,
        salesData : value.sales_lines
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      console.log(dateData)
      useEffect(()=>{
        if(dateData.data){
          const arr = dateData.data
          setPageCount(arr.length)
        }
      },[dateData])
  return (
    <Grid>
    <Grid sx={{display:"flex" , justifyContent:"space-between",padding:2,alignItems:"center"}}>
        <Button onClick={() => setActiveStep("0")} variant="contained">Back</Button>
        <Typography variant='h6'>Day reports</Typography>
        <IconButton onClick={() => {setOpen(false);setActiveStep("0") }}>
            <CloseOutlined />
        </IconButton>
    </Grid>
    <Grid>
        <CustomTable props={props}/>
    </Grid>
</Grid>
  )
}

export default DayReports